<template>
  <b-modal v-model="modal" centered no-close-on-esc no-close-on-backdrop>
    <h5 class="modal-title" slot="modal-header">Nova Licença</h5>
    <b-form-group
      label="Arquivo"
      label-for="arquivo"
      :state="!$v.arquivo.$error"
      label-class="arquivo"
    >
      <b-form-file
        id="arquivo"
        class="col col-lg-12"
        v-model="arquivo"
        size="sm"
        placeholder="Escolha o arquivo de licença"
        :state="!$v.arquivo.$error"
      ></b-form-file>
      <b-form-invalid-feedback
        >Este Campo &eacute; requerido.</b-form-invalid-feedback
      >
    </b-form-group>

    <div class="w-100" slot="modal-footer">
      <b-button
        @click="fecharModal"
        variant="default"
        size="sm"
        class="float-left"
        >Cancelar</b-button
      >
      <b-button
        @click="enviarLicenca"
        :disabled="enviandoLicenca"
        variant="success"
        size="sm"
        class="float-right"
      >
        <i class="mdi" :class="enviandoLicencaIcon"></i>
        {{ enviandoLicencaTexto }}
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ServidorApi from "../../api/servidorApi";

export default {
  name: "novaLicencaModal",
  model: {
    prop: "mostrarModal",
    event: "change"
  },
  props: {
    servidor: {
      type: Object,
      required: true
    },
    mostrarModal: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modal: this.mostrarModal,
      valor: this.servidor,
      arquivo: null,
      enviandoLicenca: false
    };
  },
  validations: {
    arquivo: { required }
  },
  computed: {
    enviandoLicencaTexto() {
      return this.enviandoLicenca ? "Enviando..." : "Enviar Licença";
    },
    enviandoLicencaIcon() {
      return this.enviandoLicenca ? "mdi-spin mdi-loading" : "mdi-upload";
    }
  },
  watch: {
    mostrarModal(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (newVal) this.$v.$reset();
      this.modal = newVal;
      this.valor = this.dispositivo;
    }
  },
  methods: {
    fecharModal() {
      this.modal = false;
      this.$emit("change", false);
      this.arquivo = null;
    },
    enviarLicenca() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.info("Invalido");
        return;
      }
      this.enviandoLicenca = true;
      ServidorApi.uploadLicenca(this.arquivo)
        .then(data => {
          this.enviandoLicenca = false;
          this.$emit("enviarLicenca", data);
          this.fecharModal();
        })
        .catch(e => {
          console.log(e);
          this.enviandoLicenca = false;
        });
    }
  }
};
</script>
<style>
.modal-title,
.arquivo {
  color: rgb(16, 42, 67);
}
</style>
